'use client';

import type { KallistoThemeTokens, ThemeTokens } from '@lmn/design-system';
import { DynamicLmnDsThemeProvider } from '@lmn/design-system';
import { IconColorsContext } from '@/app/common/icons/iconColors';

export default function ThemeProvider({
  themeTokens,
  kallistoThemeTokens,
  children,
}: {
  themeTokens: ThemeTokens;
  kallistoThemeTokens?: KallistoThemeTokens;
  children: React.ReactNode;
}) {
  return (
    <DynamicLmnDsThemeProvider themeTokens={themeTokens} kallistoTheme={kallistoThemeTokens} useCssVars={true}>
      {/* The theme above only carries var() references, which an ImageKit colorize cannot use.
          Light, because that is the mode the design system provider picks without isDarkMode. */}
      <IconColorsContext.Provider value={kallistoThemeTokens?.light.color.icon}>{children}</IconColorsContext.Provider>
    </DynamicLmnDsThemeProvider>
  );
}
